import { FC, useEffect, useRef } from 'react';

import { useChat } from '../../../lib/context/chat/ChatContext';
import { useTrackEvent } from '../../../lib/tracking/useTrack';
import { Chip } from '../../atoms/Chip';
import { Loader } from '../../atoms/Loader';
import { Message } from '../../atoms/Message';

import { MessageSenderEnum, type MessageOption, type MessageWithOptions } from '../../../lib/types/Message.type';

import styles from './MessageList.module.css';

export const MessageList: FC = () => {
    const chatContext = useChat();
    const trackEvent = useTrackEvent();
    const messagesEndRef = useRef<HTMLDivElement>(null);

    if (!chatContext) {
        return <div>Loading messages...</div>;
    }



    const { messages, sendMessage, conversationState, setConversationState, isLoading } = chatContext;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages])

    const lastMessage = messages[messages.length - 1];

    const handleOptionClick = (option: MessageOption) => {
        console.log('option', option)
        trackEvent('option_click', {
            // action: option.,
            // Set global value from context.
            prevMessage: lastMessage,
            state: conversationState,
        });
        sendMessage({ type: MessageSenderEnum.human, content: option.message as string });

        if (conversationState === '') {
            if (option.message) {
                setConversationState('option.content');
                sendMessage({ type: MessageSenderEnum.ai, content: "Please share your goals or any other information that might help us assist you." });
            }
        }
    };

    return (
        <div className={styles.messageList}>
            {messages?.map((msg, index: number) => (
                <div key={index}>
                    <Message owner={msg.type}>
                        {msg.content}
                    </Message>
                    {msg.component && <div className={styles.embeddedComponent}>{msg.component}</div>}
                    {lastMessage?.options && (
                        <div className={styles.options}>
                            {
                                lastMessage?.options?.map((option, index: number) => (
                                    <Chip
                                        key={index}
                                        onClick={() => handleOptionClick(option)}
                                    >
                                        {(option?.message as MessageWithOptions)?.answer || (option?.message as string)}
                                    </Chip>
                                ))
                            }
                        </div>
                    )}
                </div>
            ))}
            <div ref={messagesEndRef} />
            {isLoading && (
                <Loader />
            )}
        </div>
    );
};

